import React, { useState, useCallback, useEffect } from "react";
import styles from "./SelectCompanyLogin.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import store from "../../Store/Store";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import config from "../../config/config";
import { useSearchParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export default function SelectCompanyLogin() {
  const [searchParams] = useSearchParams();
  const [SearchComp, setSearchComp] = useState("");
  const [data, setData] = useState([]);
  const [auth, setAuth] = useState(null);
  const [NoCompany, setNoCompany] = useState(false);
  const [selectCompany, setSelectedCompany] = useState(null);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let tokens = localStorage.getItem("authToken");
  let parsedTokens = JSON.parse(tokens);
  const company_name = searchParams.get("company_name");
  const company_id = searchParams.get("ledger_label");
  // const cupi_flow = searchParams.get("cupi_flow");
  const cupi_kyc_id = searchParams.get("cupi_kyc_id");

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }

    if (company_id && data?.length > 0) {
      setLoading(true);
      // find the matching record by ledger_label
      let match = false;
      let matchedItem = {};
      data.forEach((item) => {
        if (item.ledger_label === company_name) {
          match = true;
          matchedItem = item;
        }
      });

      if (match) {
        // store the company name and id
        console.log("MATCHED--------------->", match);

        store.setCompanyName(matchedItem.brand);
        store.setCompId(matchedItem?.ledger_label);
        store.setUserType(matchedItem?.company_flow);
        store.setCompTempId(cupi_kyc_id);
        store.setKycCompanyId(matchedItem?.kyc_company_id);
        console.log("Matched company:", matchedItem);
        setLoading(false);
        navigate("/content/kyc?banner=true");
      } else {
        console.warn("No company found for company_id:", company_id);
        setLoading(false);
      }
    }
  }, [company_id, data, navigate]);

  useEffect(() => {
    setNoCompany(false);
  }, [selectCompany]);

  const verifyTokens = (authData) => {
    if (!authData || !authData.IdToken) {
      navigate("/login");
      return;
    }

    const expired = isTokenExpired(authData.IdToken);

    if (expired) {
      getNewTokens(authData);
    }
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        setAuth(newAuthToken); // Update state
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    let parsedAuth = JSON.parse(auth);
    if (parsedAuth.IdToken) {
      verifyTokens(parsedAuth);
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_companies`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {},
    };

    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const companyChange = (data) => {
    console.log("data", data);
    setSelectedCompany(data);
  };

  const getUsersAccess = async (compid) => {
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    let token = parsedTokens.IdToken;
    let getNewTokens = jwtDecode(token);
    console.log("getNewTokens", getNewTokens);
    let ownerAccess = getNewTokens["custom:cupi_owner"];
    ownerAccess = ownerAccess ? ownerAccess : [];
    let AdminAccess = getNewTokens["custom:cupi_admin"];
    AdminAccess = AdminAccess ? AdminAccess : [];
    console.log("ownerAccess", ownerAccess);
    console.log("AdminAccess", AdminAccess);
    const userOwnerAccess = ownerAccess.includes(compid);
    const userAdminAccess = AdminAccess.includes(compid);
    console.log("userOwnerAccess", userOwnerAccess);
    console.log("userAdminAccess", userAdminAccess);
    if (userOwnerAccess) {
      console.log("===============this user is a OWNER===============");
      store.setIsUserAdmin(true);
      store.setIsUserOwner(true);
    } else if (userAdminAccess) {
      store.setIsUserOwner(false);
      console.log("===============this user is a Admin===============");
      store.setIsUserAdmin(true);
    }
  };

  const processed = async () => {
    if (!selectCompany) {
      return;
    }
    await getUsersAccess(selectCompany.ledger_label);
    console.log("SelectedComp", selectCompany);
    if (selectCompany == null) {
      // alert("Please select a brand to Proceed.");
      setNoCompany(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setNoCompany(false);
      return;
    }
    console.log("SelectedComp", selectCompany);

    store.setCompanyName(selectCompany?.brand);
    store.setCompId(selectCompany?.ledger_label);
    store.setUserType(selectCompany?.company_flow);
    store.setKycCompanyId(
      selectCompany?.kyc_company_id ? selectCompany?.kyc_company_id : null,
    );
    navigate("/content");
  };

  // Filter companies based on the search input
  const filteredCompanies = data.filter((company) =>
    company.brand.toLowerCase().includes(SearchComp.toLowerCase()),
  );

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} sx={{ color: "#2348AB" }} />
        </div>
      )}
      <div className={styles.logincontainer}>
        <div className={styles.card}>
          <div className={styles.welcomeToEscrowStackParent}>
            <img alt="" src="./Final_Cupi.svg" />
          </div>
          <div className={styles.welcomeToEscrowStackParent}>
            <div className={styles.welcomeToEscrow}>
              Please Select the Brand to Continue
            </div>
          </div>
          <div className={styles.innercard}>
            <div className={styles.welcomeSelectBrand}>
              <div className={styles.welcomeselect}>Select Brand</div>
            </div>
            <div className={styles.inputoutlinedParent}>
              <div className={styles.inputoutlined}>
                <img src="./leading-icon.svg" className={styles.search} />
                {/* Filter */}
                <input
                  value={SearchComp}
                  type="text"
                  placeholder="Search Brand"
                  onChange={(e) => {
                    setSearchComp(e.target.value);
                  }}
                  className={styles.input}
                />
              </div>

              <div className={styles.companyList}>
                {filteredCompanies.map((res) => (
                  <button
                    key={res?.brand}
                    className={styles.companyItem}
                    onClick={() => {
                      companyChange(res);
                    }}
                  >
                    <img
                      alt=""
                      src={
                        selectCompany?.brand === res?.brand
                          ? "./selected.svg"
                          : "./select.svg"
                      }
                      className={styles.companyimg}
                    />
                    <div>{res?.brand}</div>
                  </button>
                ))}
                {filteredCompanies.length < 1 && <div>No Brand Found</div>}
              </div>
              {NoCompany && (
                <div className={styles.error}>
                  Please select a Brand to proceed.
                </div>
              )}
              <button
                className={styles.button}
                onClick={() => {
                  processed();
                }}
              >
                Proceed & Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
